import React from 'react';
import Navbar from '../components/Navbar';

export default function AboutUs() {
  const features = [
    { icon: '📝', title: 'Easy Exam Creation', desc: 'Create professional exams with multiple question types, negative marking, and time limits in minutes.' },
    { icon: '🏫', title: 'For Schools & Tutors', desc: 'Designed for science teachers, arts teachers, schools, and coaching institutes across India.' },
    { icon: '📊', title: 'Detailed Analytics', desc: 'Track student performance with detailed results, leaderboards, and attempt analytics.' },
    { icon: '🔒', title: 'Secure Exams', desc: 'Password-protect exams, set attempt limits, and control when students can see answers.' },
    { icon: '📱', title: 'Mobile Friendly', desc: 'Students can take exams on any device — mobile, tablet, or desktop. No app required.' },
    { icon: '📤', title: 'Bulk Upload', desc: 'Upload hundreds of questions at once using Excel. Save time with our question bank.' },
    { icon: '🏆', title: 'Leaderboard', desc: 'Motivate students with public exam leaderboards and shareable results via WhatsApp.' },
    { icon: '🎨', title: 'Custom Branding', desc: 'Add your school logo and name to PDF result sheets for a professional touch.' },
  ];
  const stats = [
    { value: '500+', label: 'Teachers & Schools' },
    { value: '10,000+', label: 'Exams Created' },
    { value: '1,00,000+', label: 'Exam Attempts' },
    { value: '99.9%', label: 'Platform Uptime' },
  ];
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <Navbar />
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '48px 20px 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>📝</div>
          <h1 style={{ fontSize: 40, fontWeight: 800, color: 'var(--text)', marginBottom: 16, lineHeight: 1.2 }}>About <span style={{ color: 'var(--primary-light)' }}>OExams</span></h1>
          <p style={{ color: 'var(--text2)', fontSize: 17, maxWidth: 600, margin: '0 auto', lineHeight: 1.8 }}>OExams is India's smart online examination platform built for teachers, schools, and coaching institutes who want to conduct professional digital exams — quickly and effortlessly.</p>
        </div>
        <div style={{ background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.25)', borderRadius: 20, padding: '36px', marginBottom: 48, textAlign: 'center' }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>🎯</div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: 'var(--text)', marginBottom: 16 }}>Our Mission</h2>
          <p style={{ color: 'var(--text2)', fontSize: 16, lineHeight: 1.9, maxWidth: 680, margin: '0 auto' }}>We believe every teacher and school deserves access to professional-grade examination tools. Our mission is to make digital exams <strong style={{ color: 'var(--primary-light)' }}>simple, affordable, and powerful</strong> for educators across India.</p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 48 }}>
          {stats.map((s, i) => (
            <div key={i} className="card" style={{ textAlign: 'center', padding: '28px 16px' }}>
              <div style={{ fontSize: 32, fontWeight: 800, color: 'var(--primary-light)', marginBottom: 6 }}>{s.value}</div>
              <div style={{ color: 'var(--text2)', fontSize: 13 }}>{s.label}</div>
            </div>
          ))}
        </div>
        <h2 style={{ fontSize: 26, fontWeight: 800, color: 'var(--text)', marginBottom: 24, textAlign: 'center' }}>What We Offer</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, marginBottom: 48 }}>
          {features.map((f, i) => (
            <div key={i} className="card" style={{ padding: '22px 24px' }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{f.icon}</div>
              <div style={{ fontWeight: 700, color: 'var(--text)', fontSize: 15, marginBottom: 6 }}>{f.title}</div>
              <div style={{ color: 'var(--text2)', fontSize: 13, lineHeight: 1.7 }}>{f.desc}</div>
            </div>
          ))}
        </div>
        <div className="card" style={{ marginBottom: 48, padding: '32px' }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', marginBottom: 20, textAlign: 'center' }}>Who Uses OExams?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
            {[
              { icon: '🔬', label: 'Science Teachers', desc: 'Physics, Chemistry, Maths, Biology' },
              { icon: '🎨', label: 'Arts Teachers', desc: 'History, Geography, Literature, Civics' },
              { icon: '🏫', label: 'Schools', desc: 'Conduct class tests and unit exams' },
              { icon: '📚', label: 'Coaching Institutes', desc: 'JEE, NEET, UPSC, and competitive prep' },
            ].map((item, i) => (
              <div key={i} style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 12, padding: '20px', textAlign: 'center' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>{item.icon}</div>
                <div style={{ fontWeight: 700, color: 'var(--text)', fontSize: 14, marginBottom: 4 }}>{item.label}</div>
                <div style={{ color: 'var(--text2)', fontSize: 12 }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ textAlign: 'center', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 20, padding: '40px 32px' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🚀</div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: 'var(--text)', marginBottom: 12 }}>Ready to get started?</h2>
          <p style={{ color: 'var(--text2)', marginBottom: 24, fontSize: 15 }}>Join hundreds of teachers and schools already using OExams.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/#/register" style={{ display: 'inline-block', background: 'var(--primary)', color: 'white', padding: '12px 28px', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: 15 }}>📝 Register Free</a>
            <a href="/#/contact" style={{ display: 'inline-block', background: 'var(--card2)', color: 'var(--text)', padding: '12px 28px', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: 15, border: '1px solid var(--border)' }}>📧 Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  );
}
